import { Clock, CalendarClock } from "lucide-react";
import { formatZostava, popisNajblizsieho } from "../../features/uzavierka";
import "./UzavierkaObjednavok.scss";

/**
 * Jeden riadok o tom, dokedy sa da objednat na dnes.
 *
 * Stav pocita `useUzavierka` u volajuceho, nie tu: kosik podla neho zaroven
 * zatvara dnesok, ked uzavierka prejde, a dva casovace by sa vedeli o par
 * sekund rozist -- riadok by tvrdil "este minutu" pod zavretym tlacidlom.
 *
 * Bez `aria-live`: text sa meni kazdu minutu a citacka by ho opakovala
 * dookola. Kto ho chce, precita si ho.
 */
function UzavierkaObjednavok({ stav, className = "" }) {
  if (!stav) return null;

  const triedy = (modifikator) =>
    ["uzavierka", modifikator && `uzavierka--${modifikator}`, className].filter(Boolean).join(" ");

  if (stav.typ === "otvorene") {
    return (
      <p className={triedy(stav.nalehave && "nalehave")}>
        <Clock size={16} aria-hidden="true" />
        <span>
          {/* Medzera pred „·“ je MIMO nezalomiteľného spanu -- riadok sa tak
              smie zlomiť len pred „· do 18:00“, nikdy medzi „do“ a časom. */}
          Objednávky na dnes ešte <strong>{formatZostava(stav.zostavaMinut)}</strong>{" "}
          <span className="uzavierka__cas">· do {stav.do}</span>
        </span>
      </p>
    );
  }

  const najblizsie = stav.najblizsi && (
    <> Najbližšie objednáte na <strong>{popisNajblizsieho(stav.najblizsi, stav.dnes)}</strong>.</>
  );

  if (stav.typ === "po-uzavierke") {
    return (
      <p className={triedy("zavrete")}>
        <CalendarClock size={16} aria-hidden="true" />
        <span>
          Na dnes sa objednávalo do {stav.do}.{najblizsie}
        </span>
      </p>
    );
  }

  return (
    <p className={triedy("zavrete")}>
      <CalendarClock size={16} aria-hidden="true" />
      <span>{najblizsie}</span>
    </p>
  );
}

export default UzavierkaObjednavok;
